"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RUGBY_POINTS = exports.RUGBY_CONFIGURATION = exports.PlayCode = void 0;
var PlayCode;
(function (PlayCode) {
    PlayCode["Try"] = "try";
    PlayCode["Conversion"] = "conversion";
    PlayCode["PenaltyGoal"] = "penalty_goal";
    PlayCode["DropGoal"] = "drop_goal";
})(PlayCode = exports.PlayCode || (exports.PlayCode = {}));
exports.RUGBY_CONFIGURATION = {
    play_codes: Object.values(PlayCode),
};
exports.RUGBY_POINTS = {
    penalty_goal: 3,
    drop_goal: 3,
    conversion: 2,
    try: 5,
};
//# sourceMappingURL=definitions.js.map